
import { Component, Prop, Vue } from "vue-property-decorator";
import MatchInterface from "@/libs/model/MatchInterface";

@Component({
  components: {},
})
export default class MatchStatus extends Vue {
  name: 'MatchStatus';
  @Prop() matchdata: MatchInterface;
  get time() {
    let dateTime = new Date(`${this.matchdata.matchInfo.date.replace('Z','')}T${this.matchdata.matchInfo.time}`);
    return new Intl.DateTimeFormat('en-SG', {hour: 'numeric', minute: 'numeric'}).format(dateTime);

    // Below is temporarily commented.Will be used in results. Right now everything is treated as fixture
    // if(typeof(this.matchdata.liveData.matchDetails.scores) !== 'undefined' ){
    //   if(typeof(this.matchdata.liveData.matchDetails.scores.pen) != "undefined" && this.matchdata.liveData.matchDetails.scores.pen !== null) {
    //     return "FT(P)";
    //   }
    //   return "FT";
    // }
    // return "";
  }
}
